import { StrictMode, useState, useEffect } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { theme } from "./mui/theme.ts";
import { ThemeProvider } from "@emotion/react";
import "../src/css/main.scss";
import { BrowserRouter } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { Provider } from "react-redux";
import "./config/prototypes.ts";
import store from "./store/store.ts";
import { initializeFirebaseAuth } from "./config/firebase.ts";
import LoadingPage from "./pages/LoadingPage.tsx";

const Root = () => {
  const [isFirebaseInitialized, setIsFirebaseInitialized] = useState(false);

  useEffect(() => {
    // Wait for Firebase to initialize and set persistence
    const initFirebase = async () => {
      try {
        await initializeFirebaseAuth();
        setIsFirebaseInitialized(true); // Mark Firebase as initialized
      } catch (error) {
        console.error("Error initializing Firebase:", error);
      }
    };
    initFirebase();
  }, []);

  // Show a loading screen until Firebase is initialized
  if (!isFirebaseInitialized) {
    return (
      <Provider store={store}>
        <LoadingPage covrage="full" outsideLoading={true} />
      </Provider>
    );
  }

  return (
    <StrictMode>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Provider store={store}>
            <App />
          </Provider>
        </LocalizationProvider>
      </BrowserRouter>
    </ThemeProvider>
   </StrictMode>
  );
};

createRoot(document.getElementById("root")!).render(<Root />);
